let Cookie = require('../vendor/js.cookie.js');

let siteHeader = $('.site-header'),
    mobileMenuToggle = $('.menu-toggle'),
    mobileMenuClose = $('.mobile-menu-close'),
    mobileMenuContainer = $('#site-navigation .top-nav'),
    subNavToggles = $('.nav-menu-item-with-subnav'),
    mainNavItems = $('.top-nav-item.has-dropdown');

if ($(window).scrollTop() > 0) {
    siteHeader.addClass('scrolled');
} else {
    siteHeader.removeClass('scrolled');
}

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 0) {
        siteHeader.addClass('scrolled');
    } else {
        siteHeader.removeClass('scrolled');
    }
});

mainNavItems.on('click', function (e) {

    e.preventDefault();

    let dropdownContainer = $(this).find('.main-nav-menu');

    if(!$(this).hasClass('menu-open')) {
        let otherNavItems = $('.main-nav-menu').not(dropdownContainer);
        otherNavItems.removeClass('showing');

        let continueTimeout = 0;
        if(otherNavItems.hasClass('menu-is-active')) {
            continueTimeout = 300;
        }

        setTimeout(function () {
            otherNavItems.removeClass('menu-is-active');

            mainNavItems.not(this).removeClass('menu-open');

            $('body').css({'overflow':'hidden'});
            // window.scrollTo(0,0);
            // $(document).bind('scroll',function () {
            //     window.scrollTo(0,0);
            // });

            $(this).addClass('menu-open');
            dropdownContainer.addClass('menu-is-active');
            setTimeout(function () {
                dropdownContainer.addClass('showing');
                siteHeader.addClass('menu-open');
            }, 10);
        }.bind(this), continueTimeout);
    } else {
        $(this).removeClass('menu-open');
        $(document).unbind('scroll');
        $('body').css({'overflow':'visible'});
        dropdownContainer.removeClass('showing');
        siteHeader.removeClass('menu-open');
        setTimeout(function () {
            dropdownContainer.removeClass('menu-is-active');
        }, 310);
    }

});

subNavToggles.on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parent().find('.sub-navigation-menu').slideToggle();
});

$('.main-nav-menu').each(function () {

    let menu = $(this),
        navMenuItems = $(this).find('.nav-menu-item a'),
        sidebarItems = $(this).find('.sidebar-container-item'),
        closeButton = $(this).find('.menu-close-button');

    closeButton.on('click', function () {
        menu.removeClass('showing');
        siteHeader.removeClass('menu-open');
        mainNavItems.removeClass('menu-open');
        setTimeout(function () {
            menu.removeClass('menu-is-active');
            $('body').css({'overflow':'visible'});
            $(document).unbind('scroll');
        }, 310);
    });

    navMenuItems.on('mouseenter', function () {
        let dropdownIndex = $(this).data('dropdown-index'),
            sidebarItem = menu.find('.item-' + dropdownIndex),
            timeoutCount = 0;

        sidebarItems.removeClass('item-is-active');
        sidebarItem.addClass('item-is-active');

        // if(sidebarItems.hasClass('item-is-active')) {
        //     timeoutCount = 300;
        //     sidebarItems.removeClass('showing');
        //     setTimeout(function () {
        //         sidebarItems.removeClass('item-is-active');
        //     }, 300);
        // }
        //
        // setTimeout(function () {
        //     sidebarItem.addClass('item-is-active');
        //     setTimeout(function () {
        //         sidebarItem.addClass('showing');
        //     }, 10);
        // }.bind(this), timeoutCount);
    });

});

$('.main-nav-menu').on('click', function (e) {
    e.stopPropagation();
});

mobileMenuToggle.on('click', function () {
    mobileMenuContainer.fadeIn();
    $('body').css({'overflow':'hidden'});
});

mobileMenuClose.on('click', function () {
    mobileMenuContainer.fadeOut();
    $('body').css({'overflow':'visible'});
});

let root = document.querySelector(':root');

if($('.site-alert').length) {
    let alertVersion = $('.site-alert').data('version');

    if(Cookie.get('site-alert-closed-' + alertVersion) === 'true') {
        $('.site-alert').hide();
    } else {
        $('.site-alert').addClass('showing');
        root.style.setProperty('--alertOffset', $('.site-alert').outerHeight() + 'px');
        root.style.setProperty('--headerOverlayOffset', $('.site-header').outerHeight() + 'px');
    }

    $('.site-alert-close').on('click', function () {
        $('.site-alert').slideUp();
        root.style.setProperty('--alertOffset', '0px');
        root.style.setProperty('--headerOverlayOffset', $('.site-header').outerHeight() + 'px');

        Cookie.set('site-alert-closed-' + alertVersion, 'true', { expires: 7 });
    });
}


if($('#site-popup-main').length) {

    let sitePopup = $('#site-popup-main'),
        sitePopupVersion = sitePopup.data('version');

    if(Cookie.get('site-popup-closed-' + sitePopupVersion) === 'true') {
        // do nothing
    } else {

        setTimeout(function () {
            sitePopup.modal('show');
        }, 3000);

        setTimeout(function () {
            Cookie.set('site-popup-closed-' + sitePopupVersion, 'true', { expires: 7 });
        }, 3400);

    }

    sitePopup.on('hidden.bs.modal', function () {
        Cookie.set('site-popup-closed-' + sitePopupVersion, 'true', { expires: 7 });
    });

}
